import type { SessionClaimsView } from '@/hooks/use-session-claims';
import { TGD_ROLES } from '@/lib/auth/tgd-roles';

type DirectoryClaims = Pick<
  SessionClaimsView,
  'isSuperAdmin' | 'isAccountManager' | 'isPartnerAdmin' | 'tgdRoles' | 'whitelabelScope'
>;

/** Mirror of the server gate on `partners.listIamUsers` (`canManagePartners('list')`). */
export function canSeeIamDirectory(claims: DirectoryClaims): boolean {
  const isPlatformOps =
    !claims.whitelabelScope &&
    (claims.tgdRoles.includes(TGD_ROLES.PAYMENT_OPS) || claims.tgdRoles.includes(TGD_ROLES.TAGADAPAYMENT_ADMIN));
  return claims.isSuperAdmin || isPlatformOps || claims.isAccountManager || claims.isPartnerAdmin;
}
